"use client";

import React from "react";
import Link from "next/link";

interface bannerHeroProps {
  title: string;
  bgImage: string;
  breadcrumb?: string;
  className?: string; // optional additional class
  
}

const BannerHero: React.FC<bannerHeroProps> = ({
  title,
  bgImage,
  breadcrumb = "Home",
  className=""
  
}) => {
  return (
    <div
          className={`banner-area  ${className}`}

      // style={{
      //   backgroundImage: `url(${bgImage})`,
      
        
      // }}
    >
      <div className="d-table">
        <div className="d-table-cell">
          <div className="container">
            <div className="page-title-content">
              <h2>{title}</h2>

              <ul>
                <li>
                  <Link href="/">{breadcrumb}</Link>
                 <i className="fa-solid fa-angles-right"></i>
                  <p className="active">{title}</p>
                </li>
              </ul>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BannerHero;
